/**
 * Показ адреса: рабочая строка и детали.
 *
 * У заказа нового контракта два разных значения. **Адрес** — город, улица,
 * дом: по нему считаются координаты и строится маршрут. **Детали** — регион,
 * квартира или офис, «Другое»: их читает человек, и наружу они не уходят
 * никогда.
 *
 * Правило показа одно на всё приложение, потому что решение здесь ровно одно
 * и ошибиться в нём можно молча: склей мы детали с адресом «чтобы было видно»,
 * и первый же экран, откуда адрес копируют в поиск, отправил бы курьера искать
 * квартиру вместо дома. А спрячь мы детали как «необязательные» — курьер
 * встал бы у подъезда без номера квартиры.
 *
 * Пустые детали блока не создают вовсе: пустая подпись выглядит как потерянное
 * значение, а у заказа прежнего контракта деталей просто не существует —
 * сервер присылает `null`.
 */

export interface AddressView {
  /** Рабочая строка. Пусто заменяется явной подписью, а не пустотой. */
  address: string;
  /** Вторая строка. `null` — второй строки нет. */
  details: string | null;
}

/** Пустая строка значением не считается: она неотличима от отсутствия. */
function text(value: string | null | undefined): string | null {
  if (value === null || value === undefined) {
    return null;
  }
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
}

export const ADDRESS_MISSING = 'Адрес не указан';

export function addressView(
  order: { address?: string | null; addressDetails?: string | null },
  missing: string = ADDRESS_MISSING,
): AddressView {
  return {
    address: text(order.address) ?? missing,
    details: text(order.addressDetails),
  };
}
